import { useSelector } from "react-redux";

/** Keep entity mutations disabled until its status is known. DOC*/
export const useEntityReadOnly = entityID => {
    const statuses = useSelector(state => state.userPref.EntityStatuses);
    if (!entityID) return false;
    return !statuses ||
        !Object.prototype.hasOwnProperty.call(statuses, entityID) ||
        statuses[entityID] === "Deactivated";
};
